import { render, staticRenderFns } from "./CruiseRoomDetail.vue?vue&type=template&id=75e28551&scoped=true&"
import script from "./CruiseRoomDetail.vue?vue&type=script&lang=js&"
export * from "./CruiseRoomDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e28551",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75e28551')) {
      api.createRecord('75e28551', component.options)
    } else {
      api.reload('75e28551', component.options)
    }
    module.hot.accept("./CruiseRoomDetail.vue?vue&type=template&id=75e28551&scoped=true&", function () {
      api.rerender('75e28551', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/cruise/cruiseroom/CruiseRoomDetail.vue"
export default component.exports